import { supportedLanguages } from '../contants';
import { intlData } from '../translations';
import type { MessageKey } from '../translations/types';

export const isMessageKey = (key: string | number | symbol): key is MessageKey =>
    supportedLanguages.every(lang => Object.hasOwn(intlData[lang], key));
